<!-- AlgerianPriceReader.vue -->
<template>
    <div class="algerian-price-reader">
        <button class="btn-speaker" @click.stop="readPrice" :title="$t('action.listenPrice') || 'إسمع السعر'"
            :disabled="isReading">
            <span class="mdi" :class="isReading ? 'mdi-loading mdi-spin' : 'mdi-volume-high'"></span>
        </button>
    </div>
</template>

<script>
export default {
    name: "AlgerianPriceReader",
    props: {
        price: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            voixArabe: null,
            isReading: false
        };
    },
    mounted() {
        this.loadVoices();
        if (window.speechSynthesis) {
            window.speechSynthesis.onvoiceschanged=this.loadVoices;
        }
    },
    methods: {
        loadVoices() {
            if (!window.speechSynthesis) return;
            const voices=window.speechSynthesis.getVoices();
            this.voixArabe=voices.find(v => v.lang.startsWith("ar"));
        },
        convertToDarija(montant) {
            // تحويل للسنتيم (x100)
            montant=montant*100;

            if (montant===0) return "صفر";
            const unites=["", "واحد", "زوج", "تلاتة", "ربعة", "خمسة", "ستة", "سبعة", "تمنية", "تسعة"];
            const dizaines=["", "عشرا", "عشرين", "تلاتين", "ربعين", "خمسين", "ستين", "سبعين", "تمانين", "تسعين"];
            const centaines=["", "ميا", "ميتين", "تلاتم يا", "ربعم يا", "خمسم يا", "ستم يا", "سبعم يا", "تمنم يا", "تسعم يا"];

            const speciaux={
                11: "حداش",
                12: "طناش",
                13: "تلطاش",
                14: "ربعطاش",
                15: "خمسطاش",
                16: "ستاش",
                17: "سبعطاش",
                18: "تمنطاش",
                19: "تسعطاش",

                // 21 → 29
                21: "واحد و عشرين",
                22: "اثنين و عشرين",
                23: "تلاتة و عشرين",
                24: "ربعة و عشرين",
                25: "خمسة و عشرين",
                26: "ستة و عشرين",
                27: "سبعة و عشرين",
                28: "تمنية و عشرين",
                29: "تسعة و عشرين",

                // 31 → 39
                31: "واحد و تلاتين",
                32: "اثنين و تلاتين",
                33: "تلاتة و تلاتين",
                34: "ربعة و تلاتين",
                35: "خمسة و تلاتين",
                36: "ستة و تلاتين",
                37: "سبعة و تلاتين",
                38: "تمنية و تلاتين",
                39: "تسعة و تلاتين",

                // 41 → 49
                41: "واحد و ربعين",
                42: "اثنين و ربعين",
                43: "تلاتة و ربعين",
                44: "ربعة و ربعين",
                45: "خمسة و ربعين",
                46: "ستة و ربعين",
                47: "سبعة و ربعين",
                48: "تمنية و ربعين",
                49: "تسعة و ربعين",

                // 51 → 59
                51: "واحد و خمسين",
                52: "اثنين و خمسين",
                53: "تلاتة و خمسين",
                54: "ربعة و خمسين",
                55: "خمسة و خمسين",
                56: "ستة و خمسين",
                57: "سبعة و خمسين",
                58: "تمنية و خمسين",
                59: "تسعة و خمسين",

                // 61 → 69
                61: "واحد و ستين",
                62: "اثنين و ستين",
                63: "تلاتة و ستين",
                64: "ربعة و ستين",
                65: "خمسة و ستين",
                66: "ستة و ستين",
                67: "سبعة و ستين",
                68: "تمنية و ستين",
                69: "تسعة و ستين",

                // 71 → 79
                71: "واحد و سبعين",
                72: "اثنين و سبعين",
                73: "تلاتة و سبعين",
                74: "ربعة و سبعين",
                75: "خمسة و سبعين",
                76: "ستة و سبعين",
                77: "سبعة و سبعين",
                78: "تمنية و سبعين",
                79: "تسعة و سبعين",

                // 81 → 89
                81: "واحد و تمانين",
                82: "اثنين و تمانين",
                83: "تلاتة و تمانين",
                84: "ربعة و تمانين",
                85: "خمسة و تمانين",
                86: "ستة و تمانين",
                87: "سبعة و تمانين",
                88: "تمنية و تمانين",
                89: "تسعة و تمانين",

                // 91 → 99
                91: "واحد و تسعين",
                92: "اثنين و تسعين",
                93: "تلاتة و تسعين",
                94: "ربعة و تسعين",
                95: "خمسة و تسعين",
                96: "ستة و تسعين",
                97: "سبعة و تسعين",
                98: "تمنية و تسعين",
                99: "تسعة و تسعين"
            };


            let resultat=[];

            // ملايير
            const milliards=Math.floor(montant/1000000000);
            if (milliards>0) {
                if (milliards===1) {
                    resultat.push("مليار");
                } else if ((milliards>1&&milliards<11)||(milliers%100000000>2&&milliers%100000000<11)) {
                    resultat.push(this.convertirNombreSimple(milliards, millions, unites, dizaines, centaines, speciaux)+" ملاير");
                }
                else {
                    resultat.push(this.convertirNombreSimple(milliards, millions, unites, dizaines, centaines, speciaux)+" مليار");
                }
                montant=montant%1000000000;
            }

            // ملايين
            const millions=Math.floor(montant/1000000);
            if (millions>0) {
                if (millions===1) {
                    resultat.push("مليون");
                } else if ((millions>1&&millions<11)||(millions%100000>2&&millions%100000<11)) {
                    resultat.push(this.convertirNombreSimple(millions, unites, dizaines, centaines, speciaux)+" ملاين");
                }
                else {
                    resultat.push(this.convertirNombreSimple(millions, unites, dizaines, centaines, speciaux)+" مليون");
                }
                montant=montant%1000000;
            }

            // آلاف
            const milliers=Math.floor(montant/1000);
            if (milliers>0) {
                if (milliers===1) {
                    resultat.push("ألف");
                } else if (milliers===2) {
                    resultat.push("ألفين");
                } else if ((milliers>2&&milliers<11)||(milliers%100>2&&milliers%100<11)) {
                    resultat.push(this.convertirNombreSimple(milliers, unites, dizaines, centaines, speciaux)+" الاف");
                } else {
                    console.log(milliers);
                    resultat.push(this.convertirNombreSimple(milliers, unites, dizaines, centaines, speciaux)+" ألف");
                }
                montant=montant%1000;
            }

            if (montant>0) {
                resultat.push(this.convertirNombreSimple(montant, unites, dizaines, centaines, speciaux));
            }

            return resultat.join(" و ");
        },
        convertirNombreSimple(n, unites, dizaines, centaines, speciaux) {
            if (n===0) return "";
            if (n<10) return unites[n];
            if (speciaux[n]) return speciaux[n];
            if (n<100) {
                const d=Math.floor(n/10);
                const u=n%10;
                if (u===0) return dizaines[d];
                return dizaines[d]+" و "+unites[u];
            }

            const c=Math.floor(n/100);
            const reste=n%100;
            let texte=centaines[c];

            if (reste>0) {
                if (reste<10) {
                    texte+=" و "+unites[reste];
                } else if (speciaux[reste]) {
                    texte+=" و "+speciaux[reste];
                } else {
                    const d=Math.floor(reste/10);
                    const u=reste%10;
                    if (u===0) {
                        texte+=" و "+dizaines[d];
                    } else {
                        texte+=" و "+dizaines[d]+" و "+unites[u];
                    }
                }
            }
            return texte;
        },
        readPrice() {
            if (!window.speechSynthesis) {
                alert("متصفحك لا يدعم قراءة النصوص");
                return;
            }

            if (this.isReading) return;

            const texte=this.convertToDarija(this.price);

            const utterance=new SpeechSynthesisUtterance(texte);
            utterance.lang="ar-SA";
            if (this.voixArabe) utterance.voice=this.voixArabe;
            utterance.rate=0.9;
            utterance.pitch=1;

            utterance.onstart=() => {
                this.isReading=true;
            };

            utterance.onend=() => {
                this.isReading=false;
            };

            utterance.onerror=() => {
                this.isReading=false;
            };

            window.speechSynthesis.cancel();
            window.speechSynthesis.speak(utterance);
        }
    }
};
</script>

<style scoped>
.algerian-price-reader {
    display: inline-block;
}

.btn-speaker {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 20px;
    color: var(--color-nz);
}

.btn-speaker:hover:not(:disabled) {
    background: white;
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-speaker:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.mdi-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>